/* Naoko — LP „Black Friday VIP — Powiadomienie” (docs/lp-bf-vip-powiadomienie-plan.md): JS skórki naoko-bfp-*.
   Silnik zapisu, ?typ=1, wjazdu, kotwic i kopiowania to assets/naoko-vip.js; tu tylko:
   - karta w perspektywie: wirtualne płótno 400×640 (.nbfp-oc) mapowane matrix3d na 4 rogi białej karty
     na zdjęciu (data-quad-d / data-quad-m: „x,y x,y x,y x,y” w % zdjęcia, kolejno lewy górny, prawy
     górny, prawy dolny, lewy dolny) — algorytm z makiety, przeliczany przy zmianie rozmiaru i zdjęcia,
   - ruchomy napis (snippet naoko-bfp-kinetic): animacja wstrzymana poza ekranem; przy
     prefers-reduced-motion stoi (CSS).
   Każda sekcja dołącza ten skrypt — blokada drugiego uruchomienia. */
(function () {
  if (window.NaokoBfp) return;
  window.NaokoBfp = true;

  /* ---------------- Karta w perspektywie ---------------- */
  function adj(m) {
    return [
      m[4] * m[8] - m[5] * m[7], m[2] * m[7] - m[1] * m[8], m[1] * m[5] - m[2] * m[4],
      m[5] * m[6] - m[3] * m[8], m[0] * m[8] - m[2] * m[6], m[2] * m[3] - m[0] * m[5],
      m[3] * m[7] - m[4] * m[6], m[1] * m[6] - m[0] * m[7], m[0] * m[4] - m[1] * m[3]
    ];
  }
  function mul(a, b) {
    var c = [];
    for (var i = 0; i < 3; i++) for (var j = 0; j < 3; j++) {
      var s = 0;
      for (var k = 0; k < 3; k++) s += a[3 * i + k] * b[3 * k + j];
      c.push(s);
    }
    return c;
  }
  function mulv(m, v) {
    return [m[0] * v[0] + m[1] * v[1] + m[2] * v[2], m[3] * v[0] + m[4] * v[1] + m[5] * v[2], m[6] * v[0] + m[7] * v[1] + m[8] * v[2]];
  }
  function basis(p) {
    var m = [p[0], p[2], p[4], p[1], p[3], p[5], 1, 1, 1];
    var v = mulv(adj(m), [p[6], p[7], 1]);
    return mul(m, [v[0], 0, 0, 0, v[1], 0, 0, 0, v[2]]);
  }
  function parseQuad(s) {
    var n = String(s || '').match(/-?\d+(?:[.,]\d+)?/g);
    if (!n || n.length !== 8) return null;
    n = n.map(function (x) { return parseFloat(x.replace(',', '.')); });
    return [[n[0], n[1]], [n[2], n[3]], [n[4], n[5]], [n[6], n[7]]];
  }

  function initCard(root) {
    if (root.dataset.bfpCardReady) return;
    root.dataset.bfpCardReady = '1';
    var fig = root.querySelector('.nbfp-card');
    var oc = root.querySelector('.nbfp-oc');
    var img = fig && fig.querySelector('img');
    if (!fig || !oc || !img) return;
    var mq = window.matchMedia('(max-width: 760px)');

    function fit() {
      var w = img.clientWidth, h = img.clientHeight;
      if (!w || !h) return;
      var q = parseQuad(mq.matches ? (fig.dataset.quadM || fig.dataset.quadD) : fig.dataset.quadD);
      if (!q) return;
      q = q.map(function (p) { return [p[0] / 100 * w, p[1] / 100 * h]; });
      var S = [0, 0, 400, 0, 0, 640, 400, 640];
      var D = [q[0][0], q[0][1], q[1][0], q[1][1], q[3][0], q[3][1], q[2][0], q[2][1]];
      var t = mul(basis(D), adj(basis(S)));
      t = t.map(function (x) { return x / t[8]; });
      oc.style.transform = 'matrix3d(' + [t[0], t[3], 0, t[6], t[1], t[4], 0, t[7], 0, 0, 1, 0, t[2], t[5], 0, t[8]].join(',') + ')';
      oc.classList.add('is-fit');
    }

    if (img.complete) fit();
    img.addEventListener('load', fit);
    window.addEventListener('resize', fit);
    if (mq.addEventListener) mq.addEventListener('change', fit);
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(fig);
  }

  /* ---------------- Ruchomy napis: pauza poza ekranem ----------------
     Obserwujemy sekcję (napis jest obrócony i większy od niej, wystaje poza nią), klasa idzie na napis. */
  var kinIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var k = en.target.querySelector(':scope > [data-bfp-kin]');
      if (k) k.classList.toggle('is-paused', !en.isIntersecting);
    });
  }) : null;

  function initKinetic(el) {
    if (el.dataset.bfpKinReady) return;
    el.dataset.bfpKinReady = '1';
    if (kinIO && el.parentElement) kinIO.observe(el.parentElement);
  }

  function init(scope) {
    var r = scope || document;
    r.querySelectorAll('.nbfp-hold').forEach(initCard);
    r.querySelectorAll('[data-bfp-kin]').forEach(initKinetic);
  }

  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
